import {
  login,
  logout,
  getInfo
} from '@/api/login'
import {
  getToken,
  setToken,
  removeToken,
  getAgent,
  setAgent,
  removeAgent,
  getAgentInfo,
  setAgentInfo,
  removeAgentInfo,
} from '@/utils/auth'
import * as Api from '@/api/config.js';

const user = {
  state: {
    token: getToken(),
    agent_id: getAgent(),
    agent_info: getAgentInfo(),
    name: '',
    avatar: '',
    roles: [],
    config: {},
  },

  mutations: {
    SET_AGENT_INFO: (state, agent_info) => {
      state.agent_info = agent_info
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_CONFIG: (state, config) => {
      state.config = config
    }
  },

  actions: {
    // 登录
    Login({
      commit
    }, userInfo) {
      // setAgent(0)
      // setAgentInfo('')
      console.log(userInfo);
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password, userInfo.key, userInfo.code).then(response => {
          const data = response.result
          const tokenStr = data.token
          // setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          localStorage.setItem('token', tokenStr);
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetAgentConfig({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        Api.dataList({
          page: -1,
          filter: [
            ['agent_id', '', '='],
            ['group', '', '=']
          ]
        }).then(response => {
          let config = ['point_title', 'money_name', 'contribution_name', 'number_languages']
          let newconfig = {
            'point_title': {},
            'money_name': {},
            'contribution_name': {
              "value": "贡献值"
            },
            'number_languages': {}
          }

          response.result.data.forEach(item => {
            config.forEach(itm => {
              if (itm == item.name) {
                newconfig[itm] = item
              }
            })
          })
          console.log('newconfig', newconfig)
          commit('SET_CONFIG', newconfig)
          return resolve(response)
        }).catch(error => {
          console.log('GetAgentConfig error', error)
          return reject(false)
        })
      })
    },

    // 获取用户信息
    GetInfo({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        getInfo().then(response => {
          const {
            result
          } = response
          console.log(result);
          if (!result) {
            return reject('验证失败，请重新登录。')
          }

          if (result.admin && result.admin.role_ids || 1) { // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', ['admin'])
            commit('SET_NAME', result.admin.nickname)
            commit('SET_INFO', result)
            if (result.admin.agent_info) {
              let row = result.admin.agent_info
              if (row.id) {
                commit('SET_AGENT_INFO', row) //写入vuex
                localStorage.setItem('agentInfo', JSON.stringify(row));
              }
            }
          } else {
            reject('getInfo: roles must be a non-null array !')
          }

          if (response.result.admin.agent_id) {
            console.log('有agent_id')
            setAgent(response.result.admin.agent_id)
          } else {
            console.log('没有agent_id')
            setAgent(0)
          }
          if (response.result.admin.agent_id) {
            console.log('有agent_info')
            setAgentInfo(response.result.admin.agent_info)
          } else {
            console.log('没有agent_info')
            // setAgentInfo({
            //   id:1,
            //   name:'历史'
            // })
            // let obj = getAgentInfo()
            // console.log('临时缓存进去的obj',obj)
          }
          resolve(result)
        }).catch(error => {
          removeAgent()
          setAgent(0)
          reject(error)
        })
      })
    },

    // 登出
    LogOut({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        localStorage.setItem('token', '');
        localStorage.setItem('agentInfo', '');
        resolve()
      })
    },

    // 前端 登出
    FedLogOut({
      commit
    }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        localStorage.setItem('token', '');
        localStorage.setItem('agentInfo', '');
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js